import { render, staticRenderFns } from "./EstadosPago.vue?vue&type=template&id=a81438c2&"
import script from "./EstadosPago.vue?vue&type=script&lang=js&"
export * from "./EstadosPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports